import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import { depositSuccessDataTracking } from 'utils/account/payment';
import LocalStorage from 'utils/bom-dom-manipulation/local-storage';
import {
  DepositStatusMessages,
  StatusUrlNames
} from 'utils/constants/account/payment';
import { showToastError } from 'utils/generic/show-toast-error';
import { showToastWarning } from 'utils/generic/show-toast-warning';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { appendCustomCode } from 'utils/other/customCode';
import { AppendCustomCodes } from 'interfaces/generic';
import { addQuery } from 'components/QueryRoute';
import { useFetchAccountParams } from 'newhooks/account/useFetchAccountParams';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';

export const useCheckDepositReturnUrl = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const user: Record<string, any> = useSelector(getUser);
  const { accountParams } = useFetchAccountParams();

  const customCode = () => {
    if (
      accountParams &&
      +accountParams[AppendCustomCodes.APPEND_CUSTOM_CODE_DEPOSIT_FAIL]
    ) {
      const paymentInfo = JSON.parse(
        LocalStorage.getItem(storageKeyName('account', 'PAYMENT_DATA'))
      );

      appendCustomCode(
        accountParams[AppendCustomCodes.CUSTOM_CODE_DEPOSIT_FAIL],
        {
          ...user,
          ...paymentInfo
        }
      );
    }
  };

  useLayoutEffect(() => {
    if (isLoggedIn) {
      const searchObject = qs.parse(history.location.search, {
        ignoreQueryPrefix: true
      });

      if (searchObject && searchObject.message) {
        switch (searchObject.message) {
          case StatusUrlNames.CANCEL:
            showToastError(t(`account.${DepositStatusMessages.CANCEL}`));
            customCode();
            break;
          case StatusUrlNames.FAIL:
            showToastError(t(`account.${DepositStatusMessages.FAIL}`));
            customCode();
            break;
          case StatusUrlNames.PENDING:
            showToastWarning(t(`account.${DepositStatusMessages.PENDING}`));
            break;
          case StatusUrlNames.SUCCESS:
            depositSuccessDataTracking(user);

            LocalStorage.setItem(
              storageKeyName('account', 'DEPOSIT_AMOUNT'),
              'true'
            );
            break;
          default:
            showToastWarning(searchObject.message as string);
            break;
        }

        history.push(
          addQuery({
            message: undefined
          })
        );
      }
    }
  }, [isLoggedIn, accountParams]);
};
